<div class="container" #container tabindex="0">
    <canvas #editor></canvas>
</div>
<div class="absolute" #canvasContainer>

</div>
